package top.wcpe.allincore.ui.runtime.ir

import kotlin.jvm.JvmField

/**
 * 槽位数解析器接口。
 *
 * 用于 IrInterpreter 在构造 dynamic inventory / slotGrid 元素时
 * 解析 source.slotCount（运行时由 SlotProviderRegistry 实现，
 * 单测用 fake 实现）。
 */
fun interface SlotCountResolver {

    /**
     * 解析指定 source 的当前槽位数。
     *
     * @param sourceId DSL slot.source 字段的值
     * @return 槽位数；若 source 未注册返回 0（dynamic 元素将不展开）
     */
    fun resolve(sourceId: String): Int

    companion object {
        /** 默认空解析器，所有 source 返回 0。 */
        @JvmField
        val EMPTY: SlotCountResolver = SlotCountResolver { 0 }
    }
}
